import React, { useEffect, useRef } from 'react';
import Icon from '../../../components/AppIcon';

const ContextMenu = ({ position, job, onClose, onAction }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef?.current && !menuRef?.current?.contains(e?.target)) {
        onClose();
      }
    };

    const handleEscape = (e) => {
      if (e?.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  const menuItems = [
    { icon: 'Eye', label: 'View Details', action: 'view' },
    { icon: 'Edit', label: 'Edit Job', action: 'edit' },
    { icon: 'UserCheck', label: 'Reassign Contractor', action: 'reassign' },
    { icon: 'AlertTriangle', label: 'Change Priority', action: 'priority' },
    { icon: 'FileText', label: 'Add Invoice', action: 'invoice' },
    { icon: 'Paperclip', label: 'Attach Files', action: 'attach' },
    { icon: 'MessageSquare', label: 'Add Note', action: 'note' },
    { icon: 'Trash2', label: 'Delete Job', action: 'delete', danger: true }
  ];

  return (
    <div
      ref={menuRef}
      className="fixed bg-surface rounded-lg border border-border shadow-warm-xl py-2 z-[150] min-w-[200px]"
      style={{
        top: `${position?.y}px`,
        left: `${position?.x}px`
      }}
    >
      <div className="px-3 py-2 border-b border-border">
        <p className="text-xs font-semibold text-foreground font-data">{job?.id}</p>
        <p className="text-xs text-muted-foreground truncate">{job?.title}</p>
      </div>
      {menuItems?.map((item, index) => (
        <button
          key={index}
          onClick={() => {
            onAction(item?.action, job);
            onClose();
          }}
          className={`w-full flex items-center gap-3 px-3 py-2 text-sm transition-smooth hover:bg-input ${
            item?.danger ? 'text-error' : 'text-foreground'
          }`}
        >
          <Icon 
            name={item?.icon} 
            size={16} 
            color={item?.danger ? 'var(--color-error)' : 'var(--color-muted-foreground)'} 
          />
          <span className="font-caption">{item?.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ContextMenu;